// extracted by mini-css-extract-plugin
module.exports = {"container":"pageview_container__3v0yi","title":"pageview_title__1BD9Y","content":"pageview_content__2wbDG"};